// extracted by mini-css-extract-plugin
module.exports = {"content":"Error_content__2IOh6","contentButton":"Error_contentButton__7NxLS"};